import React, {Component} from 'react';
import styles from "./servicing.module.css";

class Faqs extends Component{
        constructor(props){
                super(props)
                this.state={

                }

        }
        

        render(){
                return <div className={styles.container}>
                Faqs
        </div>
        }
}

export default Faqs;